import * as React from 'react';
import { AkErrorIcon, AkWarningIcon, AkCheckCircleIcon } from '@fuegokit/fuegoicons-react';
import { StyledAlertDialogBody, StyledAlertDialogFooter, StyledDialogOverlay, StyledDialogBox, StyledAlertDialogHeader } from './styles.js';
import Dialog from '../Dialog2/Dialog2.js';
import Box from '../../components/Box/Box.js';

const AlertDialogBody = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(StyledAlertDialogBody, null, children);
};
AlertDialogBody.displayName = "AlertDialogBody";
const AlertDialogFooter = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(StyledAlertDialogFooter, null, children);
};
AlertDialogFooter.displayName = "AlertDialogFooter";
const iconMappings = {
  danger: {
    icon: /*#__PURE__*/React.createElement(AkErrorIcon, null),
    color: 'icon.danger'
  },
  warning: {
    icon: /*#__PURE__*/React.createElement(AkWarningIcon, null),
    color: 'icon.warning.default'
  },
  success: {
    icon: /*#__PURE__*/React.createElement(AkCheckCircleIcon, null),
    color: 'icon.success'
  },
  default: {
    icon: null,
    color: ''
  }
};
const AlertDialogIcon = ({
  appearance
}) => {
  const {
    icon,
    color
  } = iconMappings[appearance];
  if (appearance === 'default') {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      color
    }
  }, icon);
};
AlertDialogIcon.displayName = "AlertDialogIcon";
const AlertDialog = ({
  children,
  ...props
}) => {
  const {
    size,
    appearance,
    heading,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Dialog.Portal, null, /*#__PURE__*/React.createElement(StyledDialogOverlay, null), /*#__PURE__*/React.createElement(StyledDialogBox, {
    size: size || 'md'
  }, /*#__PURE__*/React.createElement(StyledAlertDialogHeader, null, /*#__PURE__*/React.createElement(AlertDialogIcon, {
    appearance: appearance
  }), heading), children));
};
AlertDialog.displayName = "AlertDialog";
AlertDialog.defaultProps = {
  appearance: 'default',
  size: 'md'
};
var AlertDialog$1 = AlertDialog;

export { AlertDialogBody, AlertDialogFooter, AlertDialog$1 as default };
